export const itemListToString = (list: Array<string>, conjunction: string = 'and'): string => {
  if (list.length == 1) {
    return list[0];
  } else if (list.length == 2) {
    return list.join(` ${conjunction} `);
  } else if (list.length > 2) {
    return `${list.slice(0, -1).join(', ')}, ${conjunction} ${list[list.length - 1]}`;
  }

  return '';
};

const pluralizationExceptions = {
  person: 'people',
  Person: 'People',
};

export const pluralize = (value: number, unit: string): string => {
  if (value === 1) {
    return unit;
  } else {
    return pluralizationExceptions[unit] || unit + 's';
  }
};

export const capitalize = (str: string): string => {
  return str
    .split(' ')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Semantic Versioning Comparing
 * - https://semver.org/
 * - https://stackoverflow.com/a/65687141/456536
 * - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator#options
 * - https://gist.github.com/iwill/a83038623ba4fef6abb9efca87ae9ccb
 */
export function semverCompare(a: string, b: string): number {
  if (a.startsWith(b + '-')) return -1;
  if (b.startsWith(a + '-')) return 1;
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'case', caseFirst: 'upper' });
}
